import styled from "styled-components";

export const RequiredStyle = styled.span`
  color: red;
  /* padding-left: 1%; */
`;
